import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Row, Col, Button, Carousel } from 'antd';

@inject(
  'templateStore',
  'webSettingStore',
  'CmsDiningStore'
)
@observer
class DiningCarousel extends Component {
  constructor(props) {
    super(props)
    this.state = {
    }
  }

  componentDidMount() {
  }

  itemClick = (id) => {
    this.props.history.push(`/dining/${id}`)
  }

  render() {
    const { activeTemplate } = this.props.templateStore;

    const { data: webSettting } = this.props.webSettingStore;

    const { dinings } = this.props.CmsDiningStore;

    return (
      <>
        {
          activeTemplate
            ?
            <>
              {
                webSettting
                  ?
                  <>
                    {
                      dinings.length > 0
                        ?
                        <>
                          {
                            webSettting.isHotelFacilityCarousel
                              ?
                              <>
                                <Row className='stm-carousel-container'>
                                  <Col span={24}>
                                    <Carousel
                                      autoplay
                                      autoplaySpeed={8000}
                                    >
                                      {
                                        dinings.map(item => {
                                          let firstImageUrl = '';
                                          try {
                                            let images = JSON.parse(item.bannerUrl);
                                            firstImageUrl = images[0].url;
                                          } catch {
                                            firstImageUrl = item.bannerUrl;
                                          }

                                          return (
                                            <div
                                              key={item.id}
                                              onClick={() => this.itemClick(item.id)}
                                            >
                                              <Row
                                                className='stm-margin-top-5 stm-carousel-darken'
                                                style={{
                                                  backgroundImage: 'url("' + firstImageUrl + '")',
                                                  backgroundSize: 'cover',
                                                  minHeight: 217
                                                }}
                                              >
                                                <Col span={18} className='stm-carousel'>
                                                  <span
                                                    style={{
                                                      fontFamily: activeTemplate.templateSetting.label.fontFamily,
                                                      color: activeTemplate.templateSetting.label.color,
                                                      fontSize: activeTemplate.templateSetting.label.fontSize,
                                                      lineHeight: `${activeTemplate.templateSetting.label.fontSize + 6}px`
                                                    }}
                                                  >{item.title}</span>
                                                  <br />
                                                  <span
                                                    style={{
                                                      fontFamily: activeTemplate.templateSetting.text.fontFamily,
                                                      color: activeTemplate.templateSetting.text.color,
                                                      fontSize: 11,
                                                      lineHeight: `12px`
                                                    }}
                                                  >{item.briefDescription}</span>
                                                </Col>
                                              </Row>
                                            </div>
                                          )
                                        })}
                                    </Carousel>
                                  </Col>
                                </Row>
                              </>
                              :
                              <>
                                <Row>
                                  <Col>
                                    {/* Title */}
                                    <Row>
                                      <Col
                                        span={24}
                                        className='stm-text-align-center stm-padding-top-16 stm-padding-bottom-16'
                                        style={{
                                          fontFamily: activeTemplate.templateSetting.header.fontFamily,
                                          color: activeTemplate.templateSetting.text.color,
                                          fontSize: activeTemplate.templateSetting.header.fontSize,
                                          lineHeight: `${activeTemplate.templateSetting.header.fontSize + 2}px`
                                        }}
                                      >
                                        <span>Dining</span>
                                      </Col>
                                    </Row>

                                    {/* List */}
                                    <>
                                      {
                                        dinings.map((item) => {
                                          let firstImageUrl = '';
                                          try {
                                            let images = JSON.parse(item.bannerUrl);
                                            firstImageUrl = images[0].url;
                                          } catch {
                                            firstImageUrl = item.bannerUrl;
                                          }

                                          return (
                                            <Row key={item.id}>
                                              <Col span={1} />
                                              <Col
                                                span={22}
                                                className='stm-border-radius-4 stm-margin-bottom-10'
                                                onClick={() => this.itemClick(item.id)}
                                                style={{
                                                  fontFamily: activeTemplate.templateSetting.header.fontFamily,
                                                  background: activeTemplate.templateSetting.header.backgroundColor,
                                                  color: activeTemplate.templateSetting.header.color
                                                }}
                                              >
                                                <Row>
                                                  <Col span={24}>
                                                    <img
                                                      src={firstImageUrl}
                                                      alt={item.title}
                                                      className='stm-width-100-percent stm-height-auto stm-display-block' />
                                                  </Col>
                                                </Row>
                                                <>
                                                  {
                                                    item.showBannerOnly
                                                      ?
                                                      null
                                                      :
                                                      <>
                                                        <Row className='stm-padding-16'>
                                                          <Col
                                                            span={24} className='stm-margin-bottom-8'
                                                            style={{
                                                              fontSize: activeTemplate.templateSetting.header.fontSize,
                                                              lineHeight: `${activeTemplate.templateSetting.header.fontSize + 2}px`
                                                            }}
                                                          >
                                                            <span>{item.title}</span>
                                                          </Col>
                                                          <Col
                                                            span={24}
                                                            className='stm-margin-bottom-24'
                                                            style={{
                                                              fontSize: activeTemplate.templateSetting.text.fontSize,
                                                              lineHeight: `${activeTemplate.templateSetting.text.fontSize + 4}px`
                                                            }}
                                                          >
                                                            <span>{item.briefDescription}</span>
                                                          </Col>
                                                          <Col span={24} className='stm-text-align-right'>
                                                            <Button
                                                              style={{
                                                                fontFamily: activeTemplate.templateSetting.header.fontFamily,
                                                                background: activeTemplate.templateSetting.header.color,
                                                                color: activeTemplate.templateSetting.header.backgroundColor,
                                                                fontSize: activeTemplate.templateSetting.header.fontSize,
                                                                lineHeight: `${activeTemplate.templateSetting.header.fontSize}px`
                                                              }}
                                                            >{webSettting.detailText}</Button>
                                                          </Col>
                                                        </Row>
                                                      </>
                                                  }
                                                </>
                                              </Col>
                                              <Col span={1} />
                                            </Row>
                                          )
                                        })}
                                    </>
                                  </Col>
                                </Row>
                              </>
                          }
                        </>
                        :
                        null
                    }
                  </>
                  :
                  null
              }
            </>
            :
            null
        }
      </>
    )
  }
}

export default DiningCarousel;